<template>
  <div class="CartItem__Actions">
    <button role="button" class="p5 CartItem__Remove" @click="emits('handle-change', 0)">
      {{ store.terms.remove }}
    </button>
    <div class="CartItem__Quantity" v-if="!isGiftCard && !props.disabled">
      <label class="p5">
        {{ store.terms.quantity }}
      </label>
      <div class="select-input--wrapper select-input--wrapper-cart">
        <select v-model="quantity" name="quantity" aria-label="quantity selector" class="select-input p_2 p_2--bold select-primary--small" @change="emits('handle-change', quantity)">
          <option v-for="index in maxAllowedQuantity" :key="index" :value="index">
            {{ index }}
          </option>
        </select>
        <Icon :icon="'chevron-down'" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useCartStore } from './Composables/Store';
import Icon from '../Global/Icon.vue';

const quantity = ref(1);
const store = useCartStore();
const props = defineProps({
  quantity: {
    type: Number,
    required: true,
  },
  quantityAvailable: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isGiftCard: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(['handle-change']);

const createRange = (ceiling) => Array.from({ length: ceiling }, (value, index) => (index += 1));

const maxAllowedQuantity = computed(() => {
  const range = createRange(props.quantityAvailable);
  return range.slice(0, store.$state.quantity_policy);
});

quantity.value = props.quantity;
</script>
